import { render } from "./SpaType.vue?vue&type=template&id=5e910efb"
import script from "./SpaType.vue?vue&type=script&lang=js"
export * from "./SpaType.vue?vue&type=script&lang=js"

import "./SpaType.vue?vue&type=style&index=0&id=5e910efb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__